import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import './App.css';
import ClientFinder from "./pages/ClientFinder"
import Header from "./pages/Header"
import Login from "./pages/Login"
import CompanyDetails from "./pages/CompanyDetails"
import PersonDetails from "./pages/PersonDetails"
import Settings from "./pages/Settings"
import UsageReport from "./pages/UsageReport"
import EmailGenerator from "./pages/EmailGenerator"

import { RequestManager } from './classes/RequestManager';

const root = ReactDOM.createRoot(document.getElementById('root'));
const requestManager = new RequestManager("_")

root.render(
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Header />}>
        <Route index element={<ClientFinder requestManager = {requestManager} />} />
        <Route path="clientFinder" element={<ClientFinder requestManager= {requestManager} />} />
          <Route path="login" element={<Login requestManager = {requestManager} />} />
          <Route path="companyDetails/:stripedName" element={<CompanyDetails requestManager = {requestManager} />} />
          <Route path="personDetails/:personID" element={<PersonDetails requestManager = {requestManager} />} />
          <Route path="settings" element={<Settings requestManager = {requestManager} />} />
          <Route path="usageReport" element={<UsageReport requestManager = {requestManager} />} />
          <Route path="emailGenerator" element={<EmailGenerator requestManager = {requestManager} />} />
        </Route>
      </Routes>
    </BrowserRouter>
);